import slugify from "@sindresorhus/slugify";
import { customAlphabet } from "nanoid";
import { lowercase, numbers } from "nanoid-dictionary";

const nanoid = customAlphabet(lowercase + numbers, 5);

export const generateSlug = (prefix: string) => slugify(`${prefix}-${nanoid()}`);
